import React, {useEffect, useState} from "react";
import Box from "@mui/material/Box";
import ImageDND from "../../../views/capture/Images/ImageDND";
import ImagesSlider from "../../../views/capture/Images/ImagesSlider";
import ImageModal from "../../../components/images/ImageModal";

export default function Image({ images, onUpload, onRemove, onUpdate, helperText, maxWidth = 400 }) {
  const [index, setIndex] = useState(0);
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    if (images.length > 0) {
      setOpen(true);
    }
  };

  const handleCreate = ({ variables }) => {
    onUpload(variables.images);
    setOpen(false);
  };

  useEffect(() => {
    setIndex(0);
  }, [images.length]);

  return (
    <Box px={{ md: 5, xs: 2 }} display="flex" justifyContent="center">
      <Box width="100%" maxWidth={maxWidth} sx={{ aspectRatio: "5/4" }}>
        <Box position="relative" onClick={handleOpen}>
          {images.length === 0 && <ImageDND onDrop={onUpload} helperText={helperText} />}
          <ImagesSlider list={images} index={index} onChangeIndex={setIndex} />
        </Box>
      </Box>
      {open && images[index] && (
        <ImageModal
          open
          displaySetAsDefault={false}
          closeOnSave={true}
          selectedId={images[index].id}
          images={images}
          onClose={() => setOpen(false)}
          onRemove={onRemove}
          onUpdate={onUpdate}
          onCreate={onUpload ? handleCreate : undefined}
        />
      )}
    </Box>
  );
}
